import {
  Component,
  ElementRef,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { LayoutService } from '../../services/layout.service';
import { QrcodeScannerCameraComponent } from './qrcode-scanner-camera/qrcode-scanner-camera.component';

@Component({
  selector: 'app-qrcode-scanner',
  templateUrl: './qrcode-scanner.component.html',
  styleUrls: ['./qrcode-scanner.component.css'],
})
export class QrcodeScannerComponent implements OnInit {
  @ViewChild('cameraComponent') cameraComponent: QrcodeScannerCameraComponent;
  @ViewChild('scanInput') scanInput: ElementRef<HTMLInputElement>;
  isHandset = this.layoutService.isHandset;
  cameraScannerModeActive = signal<boolean>(true);
  disableButtons = signal<boolean>(false);
  beamCode: string;

  constructor(
    public readonly dialogRef: MatDialogRef<QrcodeScannerComponent>,
    private readonly layoutService: LayoutService
  ) {}

  ngOnInit() {
    this.disableButtonsTemporarily();
    this.checkForScanningMode();
  }

  closeDialog(code: string | undefined) {
    if (this.cameraScannerModeActive()) {
      setTimeout(() => {
        this.cameraComponent.camera.stop().subscribe(() => {
          this.dialogRef.close(code);
        });
      }, 1000);
    } else {
      this.dialogRef.close(code);
    }
  }

  changeScannerMode() {
    if (this.cameraScannerModeActive()) {
      this.cameraScannerModeActive.set(false);
      this.disableButtonsTemporarily();
      localStorage.setItem('scanningMode', 'beam');
      setTimeout(() => {
        this.scanInput.nativeElement.focus();
      }, 1000);
    } else {
      this.cameraScannerModeActive.set(true);
      this.disableButtonsTemporarily();
      localStorage.setItem('scanningMode', 'camera');
    }
  }

  private disableButtonsTemporarily() {
    this.disableButtons.set(true);
    setTimeout(() => {
      this.disableButtons.set(false);
    }, 2000);
  }

  private checkForScanningMode() {
    const activeScanningMode = localStorage.getItem('scanningMode');
    if (activeScanningMode === 'beam') {
      this.cameraScannerModeActive.set(false);
      setTimeout(() => {
        this.scanInput.nativeElement.focus();
      }, 1000);
    }
  }
}
